import React, { useState, useEffect } from 'react';

// Import newly added images from the local images folder
import img3814 from "../../images/IMG_3814.jpeg";
import img3855 from "../../images/IMG_3855.jpeg";
import img3110 from "../../images/IMG_3110.jpeg";
import img3080 from "../../images/IMG_3080.jpeg";
import img3024 from "../../images/IMG_3024.jpeg";
import img3753 from "../../images/IMG_3753.jpeg";
import img3028 from "../../images/IMG_3028.jpeg";
import img3094 from "../../images/IMG_3094.jpeg";
import img2918 from "../../images/IMG_2918.jpeg";
import img3005 from "../../images/IMG_3005.jpeg";
import img3007 from "../../images/IMG_3007.jpeg";
import img2969 from "../../images/IMG_2969.jpeg";
import img2943 from "../../images/IMG_2943.jpeg";

// Original cover image placed as first slide
const coverImage = "https://cdn.prod.website-files.com/65e0da8edae1c46e590f55e2/6621fb7436e74384d85b3eb5_P1814111%20copy-p-1080.jpg";

const ImageSlider = () => {
  // Slides (only new images)
  const images = [
    coverImage, // put back original hero photo
    "https://cdn.prod.website-files.com/65e0da8edae1c46e590f55e2/6621fb73e34572af4b1a170e_P1803757-p-1080.jpg", // additional remote image
    "https://cdn.prod.website-files.com/65e0da8edae1c46e590f55e2/6621fb733cc945b04f7b482e_P1803285-p-2000.jpg", // second remote image
    "/images/Home/slider1.jpeg", // local slider image 1
    "/images/Home/slider2.jpeg", // local slider image 2
    img3814,
    img3855,
    img3110,
    img3080,
    img3024,
    img3753,
    img3028,
    img3094,
    img2918,
    img3005,
    img3007,
    img2969,
    img2943,
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  useEffect(() => {
    const autoSlide = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => clearInterval(autoSlide);
  }, []);

  return (
    <>
      <div className="relative w-full h-[300px] md:h-[90vh] bg-gray-800 rounded-xl overflow-hidden">
        {images.map((image, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${index === currentIndex ? 'opacity-100' : 'opacity-0'}`}
            style={{ pointerEvents: 'none' }}
          >
            <img src={image} alt={`Slide ${index}`} className="w-full h-full object-cover" />
          </div>
        ))}
        <button
          className="absolute left-2 md:left-6 top-1/2 transform -translate-y-1/2 block-circle z-10"
          onClick={prevSlide}
        >
          <img src="/icons/prev.svg" alt="" />
        </button>
        <button
          className="absolute right-2 md:right-6 top-1/2 transform -translate-y-1/2 block-circle z-10"
          onClick={nextSlide}
        >
          <img src="/icons/next.svg" alt="" />
        </button>
      </div>
      <p className='p-2 text-[8px] lg:text-[10px]'> <strong>Photos Courtesy:</strong> Leafwell Farm New York</p>
    </>
  );
};

export default ImageSlider;
